@if (photoUrl()) {
  <div class="provider-photo">
    <img
      src="{{ photoUrl() }}"
      alt="{{ providerName() }}'s profile photo"
    >
  </div>
} @else {
  <div class="initials">{{ initials() }}</div>
}
